<template>
  <div class="PageBox">
    <div class="ScrollBox">
      <van-tabs v-model="activeTabs" sticky offset-top="46" :ellipsis="false" color="var(--color-active)" title-active-color="var(--color-active)" @click="clickTabs">
        <van-tab v-for="tab,index in $t('Coupon[1]')" :key="index" :title="tab" title-style="font-size:15px">
          <van-list
            v-model="isLoad"
            :finished="isFinished"
            :finished-text="listData[index].length?$t('vanPull[0]'):$t('vanPull[1]')"
            :class="{Empty:!listData[index].length}"
            @load="getCouponList"
          >
            <div v-if="index==0" class="coupon-list">
              <van-checkbox-group v-model="turnData" ref="checkboxGroup" checked-color="var(--color-active)" @change="changeGroup">
                <div v-for="item,index in listData[index]" :key="index" class="check-list">
                  <van-checkbox v-if="showCheckbox" :name="item.id" />
                  <a class="item" :class="{gray:item.state!=0}" href="javascript:;" @click="item.state==0&&!showCheckbox?userCoupon(item.id,item.vip_grade,item.price):false">
                    <div class="left">
                      <h2>{{item.title}}</h2>
                      <h3>{{$t('Coupon[2][0]')}}</h3>
                      <p>{{$t('Coupon[2][1]')}}{{item.end_time}}</p>
                    </div>
                    <div class="right">
                      <div class="money">
                        <small>{{InitData.currency}}</small>
                        {{item.price}}
                      </div>
                      <span>{{$t('Coupon[2][2]')}}</span>
                    </div>
                  </a>
                </div>
              </van-checkbox-group>
            </div>
            <div v-else class="coupon-list">
              <a v-for="item,index in listData[index]" :key="index" class="item" :class="{gray:item.state!=0}" href="javascript:;" @click="item.state==0?userCoupon(item.id,item.vip_grade,item.price):false">
                <div class="left">
                  <h2>{{item.title}}</h2>
                  <h3>{{$t('Coupon[2][0]')}}</h3>
                  <p>{{$t('Coupon[2][1]')}}{{item.end_time}}</p>
                </div>
                <div class="right">
                  <div class="money">
                    <small>{{InitData.currency}}</small>
                    {{item.price}}
                  </div>
                  <span>{{$t('Coupon[2][2]')}}</span>
                </div>
              </a>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
      <div v-if="activeTabs==0&&listData[0].length" class="bottom-action">
        <div class="fixed-box">
          <van-field
            v-if="showCheckbox"
            v-model="toUser"
            label-width="auto"
            center
            clearable
            :placeholder="$t('Coupon[4][1]')"
            style="padding: 12px"
          >
            <template #label>
              <van-checkbox v-model="checkedAll" checked-color="var(--color-active)" @change="checkAll">{{$t('Coupon[4][0]')}}</van-checkbox>
            </template>
            <template #button>
              <van-button size="small" type="danger" round :disabled="turnData.length?false:true" style="padding: 0 15px" @click="submitTurn">{{$t('Coupon[4][2]')}}</van-button>
              <van-button size="small" round style="border:1px #ccc solid;margin-left: 5px;" @click="cancelTurn">{{$t('Coupon[4][3]')}}</van-button>
            </template>
          </van-field>
          <div v-else style="padding: 10px">
            <van-button type="danger" round block @click="showCheckbox=true">{{$t('Coupon[3]')}}{{$t('Coupon[0]')}}</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Coupon',
  components: {
  },
  props: ['vipGrade','isPopup'],
  data() {
    return {
      activeTabs: 0,
      listData: [],
      pageNo: 1,
      isLoad: false,
      isFinished: false,
      showCheckbox: false,
      toUser: '',
      checkedAll: false,
      turnData: [],
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.listData = this.$t('Coupon[1]').map(item=>[])
    this.$parent.navBarTitle = this.$t('Coupon[0]')
  },
  mounted() {
 
  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    cancelTurn() {
      this.showCheckbox = false
      this.toUser = ''
      this.checkedAll = false
      this.turnData = []
    },
    submitTurn() {
      if(!this.toUser){
        this.$Dialog.Toast(this.$t('Coupon[4][1]'))
        return
      }
      const coupon_id = this.turnData.join(',')
      this.$Model.CouponTransfer({username: this.toUser, coupon_id: coupon_id},data=>{
        if(data.code==1){
          this.cancelTurn()
          this.clickTabs(this.activeTabs)
        }
      })
    },
    changeGroup(data) {
      if(!this.isLoad){
        if(data.length==this.listData[0].length){
          this.checkedAll = true
        }else{
          this.checkedAll = false
        }
      }
    },
    checkAll(checked) {
      if(checked){
        this.$refs.checkboxGroup[0].toggleAll(true)
      }else{
        this.$refs.checkboxGroup[0].toggleAll()
      }
    },
    clickTabs(index) {
      this.cancelTurn()
      this.isFinished = false
      this.listData[index] = []
      this.pageNo = 1
      this.getCouponList()
    },
    getCouponList() {
      this.isLoad = true
      this.$Model.GetCouponList({state: this.activeTabs,vip_grade: this.vipGrade||'',page_no: this.pageNo},(json,data)=>{
        this.isLoad = false
        if(data.code==1){
          this.listData[json.state] = this.listData[json.state].concat(data.list)
          if(this.pageNo==data.data_total_page){
            this.isFinished = true
          }
        }else{
          this.isFinished = true
          this.listData[json.state] = []
        }
      })
    },
    userCoupon(coupon_id,grade,coupon_price){
      const vipData = this.$store.state.InitData.UserGradeList.find(item=>item.grade==grade)
      const amount = this.$Util.PointFormat(vipData.amount),
      name = vipData.name,
      state = vipData.state,
      discount = vipData.discount
      let defaultAmount = amount
      let finalAmount = amount - Number(coupon_price)
      if(Number(discount)){
        finalAmount = amount - this.$Util.KeepDecimal(amount*Number(discount)/100,2) - Number(coupon_price)
      }
      const currGrade = this.$store.state.InitData.UserGradeList.find(item=>item.grade==this.$store.state.UserInfo.vip_level)
      const currAmount = this.$Util.PointFormat(currGrade.amount)
      if(this.$store.state.UserInfo.vip_level>grade){
        this.$Dialog.Alert(this.$t('vip.dialog[1]',{currname: this.$store.state.UserInfo.useridentity,name: name}))
      }else{
        let html = ""
        if(this.$store.state.UserInfo.vip_level==grade){
          html = this.$t('vip.dialog[2]',{currency: this.$store.state.InitData.currency,amount: this.$Util.MoneyFormat(finalAmount),name: name})
        }else{
          if(this.$store.state.InitData.setting.is_ck==1){
            defaultAmount = amount - currAmount
            finalAmount = amount - currAmount - Number(coupon_price)
            if(Number(discount)){
              finalAmount = Number(defaultAmount) - this.$Util.KeepDecimal(Number(defaultAmount)*Number(discount)/100,2) - Number(coupon_price)
            }
          }
          html = this.$t('vip.dialog[0]',{currency: this.$store.state.InitData.currency,amount: this.$Util.MoneyFormat(finalAmount),name: name})
        }
        if(state==1){
          this.$Dialog.Confirm(html,()=>{
            this.$Model.BuyVip({grade:grade, coupon_id: coupon_id},data=>{
              if(data.code==1){
                if(this.isPopup){
                  this.$emit('update:closePopup',false)
                }
                this.clickTabs(this.activeTabs)
              }
              if(data.code==2){
                this.$router.push(`/user/recharge?vip=${grade}&amount=${Number(data.amount||finalAmount)}`)
              }
            })
          })
        }else{
          this.$Dialog.Toast(this.$t('dialog[11]'))
        }
      }
    },
  }
}
</script>
<style scoped>
.coupon-list{
  padding: 0 12px;
}
.coupon-list .item{
  margin: 12px 0;
  border-radius: 10px;
  background: url('../../../public/static/images/coupon_bg.png') no-repeat;
  background-size: 100% 100%;
  padding: 20px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.coupon-list .item.gray{
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  opacity: .6;
}
.coupon-list .item .right{
  background: url('../../../public/static/images/coupon_money.png') no-repeat;
  background-size: 100% 100%;
  width: 28vw;
  height: 28vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1;
  color: #3f2924;
}
.coupon-list .item .money{
  display: flex;
  font-size: 30px;
}
.coupon-list .item .money small{
  font-size: 15px;
  margin-top: 4px;
}
.coupon-list .item .right span{
  margin-top: 8px;
  font-size: 12px;
}
.coupon-list .item .left{
  line-height: 1;
  margin-right: 20px;
  text-align: center;
  flex: 1;
}
.coupon-list .item .left h2{
  font-size: 36px;
  font-style: italic;
  color: #a26531;
  font-weight: 600;
}
.coupon-list .item .left h3{
  font-size: 24px;
  font-style: italic;
  margin-top: 3px;
  color: #443326;
}
.coupon-list .item .left p{
  position: absolute;
  font-size: 12px;
  color: #3f2924;
  opacity: .6;
  bottom: 10px;
  left: 15px;
}
.bottom-action {
  height: 64px;
}
.bottom-action .fixed-box{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
.check-list {
  display: flex;
  align-items: center;
}
.check-list .van-checkbox{
  margin-right: 10px;
}
.check-list .item{
  flex: 1;
}
</style>